export const statusToggleLabels = {
    trueLabel: 'Enabled',
    falseLabel: 'Disabled'
};